import { MedicalCardRequirement } from 'src/constants/collect-data/enums'
import { DotNumberOption } from 'src/constants/partnerDriver/enums'
import type { CompleteDotNumberPayload } from 'src/interfaces/partnerDriver'
import type { CompleteDotNumberFormValues } from './CompleteDotNumberForm.interface'

/**
 * Only the number matching the chosen option is sent — the backend rejects a body carrying both.
 * A file is never sent when the step hides the medical card (the backend answers 400 to one).
 * The no-number option has no payload: it skips the step instead.
 */
export const toCompleteDotNumberPayload = (
  stepId: string,
  values: CompleteDotNumberFormValues,
  medicalCardRequirement: MedicalCardRequirement,
): CompleteDotNumberPayload | null => {
  const file = medicalCardRequirement === MedicalCardRequirement.Hidden ? null : values.file

  if (values.option === DotNumberOption.Dot) {
    return {
      stepId,
      dotNumber: values.dotNumber.trim(),
      stateOfIssue: values.stateOfIssue,
      lastSubmittedAt: values.lastSubmittedAt,
      file,
    }
  }

  if (values.option === DotNumberOption.UsDot) {
    return {
      stepId,
      usDotNumber: values.usDotNumber.trim(),
      lastSubmittedAt: values.lastSubmittedAt,
      file,
    }
  }

  return null
}
